module.exports = __webpack_public_path__ + "img/2-1.f30ead67.svg";